import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

export function errMsg(e) {
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => (d?.msg ? `${d.loc?.slice(-1)[0] || ""}: ${d.msg}` : JSON.stringify(d))).join(" ");
  return detail.msg || String(detail);
}

export const money = (n) => `$${Number(n || 0).toFixed(2)}`;

export const STATUS_TEXT = {
  draft: "Draft - not finished",
  pending_payment: "Waiting for payment",
  processing: "Paid - preparing your keepsake",
  on_hold: "On hold - our team is looking into it",
  awaiting_approval: "Ready - final check by our team",
  approved: "Approved - sending to the printer",
  in_production: "Printing your stickers",
  shipped: "Shipped",
  refunded: "Refunded",
  canceled: "Canceled",
  test_complete: "Test order - video posted, sticker emailed",
};

const productionText = (items = []) => {
  const chosen = items.filter((i) => i.quantity > 0);
  if (chosen.length && chosen.every((i) => i.kind === "qr_square")) return "Creating your order";
  const orn = chosen.filter((i) => (i.kind || "").startsWith("ornament"));
  if (!chosen.length || orn.length === chosen.length) {
    if (!chosen.length) return "Creating your keepsakes";
    return orn.reduce((n, i) => n + i.quantity, 0) > 1 ? "Creating your ornaments" : "Creating your ornament";
  }
  return orn.length ? "Creating your keepsakes" : "Printing your stickers";
};

export const statusText = (o) => (o.status === "in_production" ? productionText(o.items) : STATUS_TEXT[o.status] || o.status);

export const QR_SQUARE_PHOTO = "/img/qr-square.jpg?v=2";
export const orderImage = (o, stickerSrc) => (o.template ? stickerSrc(o) : (o.items || []).some((i) => i.kind === "qr_square" && i.quantity > 0) ? QR_SQUARE_PHOTO : null);
